import React from 'react';


function StandardsTaxonomy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Standards Taxonomy</h1>

        <div className="space-y-12">
          
          {/* SECTION 1: Identifier Structure */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Identifier Structure</h2>
            <p className="text-gray-800 leading-relaxed mb-4">
              AASC standards utilize a structured semantic identifier to ensure precise referencing. The format follows the syntax:
            </p>
            <div className="bg-gray-100 p-6 rounded-sm border border-[#E2E8F0] font-mono text-lg mb-4 text-center">
              PREFIX - DOMAIN - VERSION
            </div>
            <ul className="list-disc pl-5 space-y-2 text-[#64748B]">
              <li><strong>PREFIX (AI):</strong> Indicates the standard applies to Artificial Intelligence systems.</li>
              <li><strong>DOMAIN (4-letter Code):</strong> Identifies the specific control domain (e.g., HITL for Human in the Loop).</li>
              <li><strong>VERSION (Major.Minor):</strong> Indicates the revision level of the standard.</li>
            </ul>
          </section>

          {/* SECTION 2: Version Numbering */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Version Numbering</h2>
            <p className="text-gray-800 leading-relaxed mb-4">
              The Council employs Semantic Versioning to communicate the nature of updates:
            </p>
            <ul className="list-disc pl-5 space-y-3 text-[#64748B]">
              <li><strong>Major Version (X.0):</strong> Represents a significant change in requirements. Major versions may require operators to implement new controls to maintain compliance.</li>
              <li><strong>Minor Version (1.X):</strong> Represents clarifications, corrections, or additional guidance that does not fundamentally alter the control objective.</li>
            </ul>
          </section>

          {/* SECTION 3: Standards Evolution */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Standards Evolution</h2>
            <p className="text-gray-800 leading-relaxed">
              The evolution of standards is managed through a formal review process overseen by the Steering Committee. This process includes:
            </p>
            <ol className="list-decimal pl-5 space-y-2 text-[#64748B] mt-4">
              <li><strong>Proposal:</strong> Drafting of new standards or revisions based on industry needs.</li>
              <li><strong>Comment Period:</strong> Solicitation of feedback from subject matter experts.</li>
              <li><strong>Voting:</strong> Formal approval by the Steering Committee.</li>
              <li><strong>Publication:</strong> Release to the AASC Public Registry.</li>
            </ol>
          </section>

        </div>
      </div>
    </>
  );
}

export default StandardsTaxonomy;